module.exports = __webpack_public_path__ + "static/media/36.593be976.jpg";